export const MARKET_PRICE_PROVIDERS = ['cardtrader', 'cardmarket', 'tcgplayer'] as const;

export type MarketPriceProvider = (typeof MARKET_PRICE_PROVIDERS)[number];

export const DEFAULT_MARKET_PRICE_PROVIDER: MarketPriceProvider = 'cardtrader';

/** Providers whose card, deck, and collection prices come from a live quote sync. */
export const LIVE_QUOTE_PROVIDERS = ['cardmarket', 'cardtrader'] as const;

export const MARKET_PRICE_PROVIDER_LABELS: Record<MarketPriceProvider, string> = {
  cardtrader: 'CardTrader',
  cardmarket: 'Cardmarket',
  tcgplayer: 'TCGPlayer',
};

/** Same marks as the pricing picker in account settings. */
export const MARKET_PRICE_PROVIDER_LOGOS: Record<MarketPriceProvider, string> = {
  cardtrader: '/market-providers/cardtrader.png',
  cardmarket: '/market-providers/cardmarket.png',
  tcgplayer: '/market-providers/tcgplayer.png',
};

export const MARKET_PRICE_PROVIDER_NOTES: Record<MarketPriceProvider, string> = {
  cardtrader: 'Fetched from CardTrader listings and cached periodically.',
  cardmarket: 'Fetched daily from Cardmarket and cached in EUR.',
  tcgplayer: 'Recorded TCGPlayer market price, in USD.',
};

export const MARKET_PRICE_PROVIDER_DESCRIPTIONS: Record<MarketPriceProvider, string> = {
  cardtrader: 'Use CardTrader listing data for the chart and for card, deck, and collection values.',
  cardmarket: 'Use Cardmarket price-guide data for the chart and for card, deck, and collection values.',
  tcgplayer: 'Use the recorded TCGPlayer price for the chart and for card, deck, and collection values.',
};

export const MARKET_PRICE_PROVIDER_URLS: Record<MarketPriceProvider, string> = {
  cardtrader: 'https://www.cardtrader.com',
  cardmarket: 'https://www.cardmarket.com/en/Riftbound',
  tcgplayer: 'https://www.tcgplayer.com',
};

export function isLiveQuoteProvider(provider: string): boolean {
  return (LIVE_QUOTE_PROVIDERS as readonly string[]).includes(provider);
}

export function normalizeMarketPriceProvider(value: unknown): MarketPriceProvider {
  return MARKET_PRICE_PROVIDERS.includes(value as MarketPriceProvider)
    ? value as MarketPriceProvider
    : DEFAULT_MARKET_PRICE_PROVIDER;
}
